import { ResponseGenerator } from 'common/type';
import { trimQueryData } from 'helpers/params';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  getHblAPI,
  getHblDetailAPI,
  updateHblAPI,
  updateHblListAPI,
  getHblDocDetailAPI,
  uploadHblDocAPI,
  deleteHblDocAPI,
  validationHblDocAPI,
  uploadPortcastInfoAPI,
} from './api';
import {
  filterHbl,
  filterHblDetail,
  filterHblSuccess,
  filterHblDetailSuccess,
  filterHblFailure,
  getDetailHbl,
  getDetailHblSuccess,
  getDetailHblFailure,
  updateHblSuccess,
  updateHblFailure,
  updateHbl,
  updateHblListSuccess,
  updateHblListFailure,
  updateHblList,
  getDetailHblDoc,
  getDetailHblDocSuccess,
  getDetailHblDocFailure,
  uploadHblDoc,
  deleteHblDoc,
  getHblDocValidation,
  getHblDocValidationSuccess,
  getHblDocValidationFailure,
  uploadPortcastInfo,
} from './slice';

function* fetchHblStatus({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getHblAPI, trimQueryData(payload));
    yield put(filterHblSuccess(response.data));
  } catch (error) {
    yield put(filterHblFailure());
  }
}

function* fetchHblDetailStatus({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getHblAPI, trimQueryData(payload));
    yield put(filterHblDetailSuccess(response.data));
  } catch (error) {
    yield put(filterHblFailure());
  }
}

function* fetchHblDetail({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getHblDetailAPI, payload);
    yield put(getDetailHblSuccess(response));
  } catch (error: any) {
    yield put(getDetailHblFailure({ message: error?.message }));
  }
}

function* updateHblSaga({ payload }: any) {
  const { onSucess, onFail, data } = payload;
  try {
    const response: ResponseGenerator = yield call(updateHblAPI, { data });
    yield put(updateHblSuccess(response));
    onSucess();
  } catch (error: any) {
    yield put(updateHblFailure({ message: error?.message }));
    onFail();
  }
}

function* updateHblListSaga({ payload }: any) {
  const { onSucess, onFail, data } = payload;
  try {
    const response: ResponseGenerator = yield call(updateHblListAPI, data);
    yield put(updateHblListSuccess(response));
    onSucess();
  } catch (error: any) {
    yield put(updateHblListFailure({ message: error?.message }));
    onFail();
  }
}

function* fetchHblDocDetail({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(getHblDocDetailAPI, payload);
    yield put(getDetailHblDocSuccess(response));
  } catch (error: any) {
    yield put(getDetailHblDocFailure({ message: error?.message }));
  }
}

function* uploadHblDocSaga({ payload }: any) {
  const { onSuccess, onFail, data } = payload;

  try {
    const response: ResponseGenerator = yield call(uploadHblDocAPI, data);
    if (response.meta.code === 0) {
      onSuccess(response.data);
    } else {
      onFail(response);
    }
  } catch (error) {
    onFail('');
  }
}

function* deleteHblDocSaga({ payload }: any) {
  const { onSuccess, onFail, data } = payload;

  try {
    const response: ResponseGenerator = yield call(deleteHblDocAPI, data);
    if (response.meta.code === 0) {
      onSuccess(response.data);
    } else {
      onFail(response);
    }
  } catch (error) {
    onFail('');
  }
}

function* fetchHblDocValidationSaga({ payload }: any) {
  try {
    const response: ResponseGenerator = yield call(validationHblDocAPI, payload);
    yield put(getHblDocValidationSuccess(response));
  } catch (error: any) {
    yield put(getHblDocValidationFailure({ message: error?.message }));
  }
}

function* uploadPortcastInfoSaga({ payload }: any) {
  const { onSuccess, onFail, data } = payload;

  try {
    const response: ResponseGenerator = yield call(uploadPortcastInfoAPI, data);
    if (response.meta.code === 0) {
      onSuccess(response.data);
    } else {
      onFail(response);
    }
  } catch (error) {
    onFail('');
  }
}

function* watchHblStatus() {
  yield takeLatest(filterHbl, fetchHblStatus);
  yield takeLatest(filterHblDetail, fetchHblDetailStatus);
  yield takeLatest(getDetailHbl, fetchHblDetail);
  yield takeLatest(updateHbl, updateHblSaga);
  yield takeLatest(updateHblList, updateHblListSaga);
  yield takeLatest(getDetailHblDoc, fetchHblDocDetail);
  yield takeLatest(uploadHblDoc, uploadHblDocSaga);
  yield takeLatest(deleteHblDoc, deleteHblDocSaga);
  yield takeLatest(getHblDocValidation, fetchHblDocValidationSaga);
  yield takeLatest(uploadPortcastInfo, uploadPortcastInfoSaga);
}

export default watchHblStatus;
